module.exports = __webpack_public_path__ + "static/media/webare_bears2.3e331a56.png";